var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_320)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.579 7.92188H46.9637C47.8049 7.92188 48.5598 8.27734 49.1055 8.8444C49.6553 9.41146 50 10.1986 50 11.0534V48.8685C50 49.736 49.6553 50.5146 49.1055 51.0775C48.5557 51.6445 47.7925 52 46.9637 52H10.0443C9.20318 52 8.44822 51.6445 7.90251 51.0775C7.3527 50.5104 7.00804 49.7233 7.00804 48.8685V30.2402C8.0215 30.6634 9.08009 30.9935 10.1756 31.2093V39.7913H10.1879C15.4768 34.5736 18.9808 31.9964 24.2409 27.5911C24.2614 27.6123 24.282 27.6335 24.3025 27.6546C24.3148 27.6673 24.3148 27.68 24.3271 27.68L35.3315 41.1074L37.0138 30.4264C37.1287 29.7409 37.7523 29.2712 38.417 29.3896C38.6714 29.4277 38.9012 29.5589 39.0817 29.7324L46.8037 38.0986V11.8109C46.8037 11.6416 46.7381 11.4935 46.6232 11.3919C46.5206 11.2861 46.3688 11.2057 46.217 11.2057H30.3832C30.215 10.0716 29.9442 8.97559 29.579 7.92188ZM13.454 0C20.8846 0 26.9079 6.21224 26.9079 13.876C26.9079 21.5397 20.8846 27.752 13.454 27.752C6.02331 27.752 0 21.5397 0 13.876C0 6.21224 6.02331 0 13.454 0ZM6.30642 14.1214H10.8362V20.7907H15.9445V14.1214H20.6056L13.4581 6.95703L6.30642 14.1214ZM38.6796 15.0905C39.89 15.0905 41.002 15.6025 41.7898 16.4193C42.594 17.2487 43.0781 18.3786 43.0781 19.6312C43.0781 20.8796 42.5816 22.0264 41.7898 22.8389C40.9856 23.6683 39.89 24.1676 38.6796 24.1676C37.4692 24.1676 36.3573 23.6556 35.5654 22.8389C34.7612 22.0094 34.277 20.8796 34.277 19.6312C34.277 18.3828 34.7735 17.2402 35.5654 16.4193C36.3737 15.5898 37.4692 15.0905 38.6796 15.0905Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/upload-image-icon.c718221e33cc88d943a9907b138df316.svg";
export { ForwardRef as ReactComponent };